import type { MyBridgeAgent } from '@common/reducers/backend-api/backend-api';

/**
 * THE order of an agents list (the /agents page and the WhatsApp Quick Agents
 * sidebar): active agents first, then the most recently updated — so the agents
 * nobody has touched in a while, and that are off, sink to the bottom. A missing
 * `updatedAt` sorts as oldest; ties keep their incoming order (stable sort).
 */
export function sortAgentsForList<T extends Pick<MyBridgeAgent, 'enabled' | 'updatedAt'>>(agents: readonly T[]): T[] {
  const time = (a: T) => (a.updatedAt ? Date.parse(a.updatedAt) || 0 : 0);
  return [...agents].sort((a, b) => Number(b.enabled) - Number(a.enabled) || time(b) - time(a));
}
